<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { Invoice, InvoiceItem } from '../../../../Types/invoice'
import InvoiceItemFormDialog from './InvoiceItemFormDialog.vue'

defineProps<{
  invoice: Invoice
}>()

const emit = defineEmits<{
  itemCreated: [{ invoiceItem: InvoiceItem }]
}>()

const { n, t } = useI18n()

const selectedPurchaseOrderItemId = ref<number | null>(null)

function openInvoiceItemModal(purchaseOrderItemId: number) {
  selectedPurchaseOrderItemId.value = purchaseOrderItemId
}

function closeInvoiceItemModal() {
  selectedPurchaseOrderItemId.value = null
}

function onInvoiceItemSaved({ invoiceItem }: { invoiceItem: InvoiceItem }) {
  emit('itemCreated', { invoiceItem })
  closeInvoiceItemModal()
}
</script>

<template>
  <div class="table-responsive">
    <table class="table table-striped mb-0">
      <thead>
        <tr>
          <td colspan="5" class="font-weight-bold alert-warning">{{ t('invoice.label.allocableItem') }}</td>
        </tr>
        <tr>
          <th class="font-weight-bold col-2">{{ t('invoice.label.contract') }}</th>
          <th class="font-weight-bold col-4">{{ t('invoice.label.purchaseOrderNumbers') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.itemType') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.amount') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.amountAvailable') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in invoice.allocableItems" :key="item.id">
          <td>{{ item.purchaseOrder.contract?.label }}</td>
          <td>{{ item.purchaseOrder.number ? item.purchaseOrder.number : '-' }}</td>
          <td class="cursor-pointer text-primary" @click="openInvoiceItemModal(item.id)">
            {{ item.itemType.label }}
          </td>
          <td>{{ item.amount ? n(Number(item.amount), 'currency') : '-' }}</td>
          <td>{{ item.availableAmount ? n(Number(item.availableAmount), 'currency') : '-' }}</td>
        </tr>
      </tbody>
    </table>
    <InvoiceItemFormDialog
      v-if="selectedPurchaseOrderItemId"
      :purchase-order-item-id="selectedPurchaseOrderItemId"
      :invoice-id="invoice.id"
      @close="closeInvoiceItemModal"
      @save="onInvoiceItemSaved"
    />
  </div>
</template>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
